import React, { useState, useEffect } from 'react';
import { getDecimal } from '../config/utils';
import { getCaseLabel } from "./lookupFunctions";
import { getServiceFee } from "./selectedFunctions";
import { useSxStyles } from "../styles/sxStyles";
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid2 from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip'
import Zoom from '@mui/material/Zoom'
import PaymentsTwoToneIcon from '@mui/icons-material/PaymentsTwoTone';
import ReplayIcon from "@mui/icons-material/Replay";
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from '@mui/material/useMediaQuery'

const SelectedBalances = (props) => {
    const balances = props.balances;
    const plans = props.plans;
    const court = props.court
    const removeBalance = props.removeBalance;
    const removePlan = props.removePlan;
    const feeResponse = props.feeResponse;
    const clearSelected = props.clearSelected;
    const openPayment = props.openPayment;
    const setShowSelected = props.setShowSelected;
    const classes = useSxStyles;
    const [serviceFee, setServiceFee] = useState(null);
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        if ((balances && balances.length > 0) || (plans && plans.length > 0)) {
            setServiceFee(getServiceFee(balances, plans));
        }
    }, [balances, plans])

    return (<>
        <Typography variant='subtitle1' color='primary' sx={{fontSize: '1.2rem', fontWeight: '500', marginTop: '1rem', marginBottom: '1rem'}}>
            Selected Items
        </Typography>
        <Paper elevation={3} sx={{...classes.listContainer, maxHeight: '85vh', overflow: 'auto'}}>
            <List sx={{...classes.list, maxHeight: '100%'}} >
                {plans && plans.length > 0 && plans.map((plan) => {
                    return (<>
                        <ListItem alignItems='flex-start' sx={classes.listPadding}>
                            <ListItemText
                                sx={classes.listText}
                                primary={
                                    <Grid2
                                        container
                                        spacing={2}
                                        alignItems="top"
                                        style={{width: '100%'}}
                                    >
                                        <Grid2
                                            size={{
                                                xs: 5,
                                                lg: 3
                                            }}>
                                            <Tooltip title='Remove payment plan from selected list' arrow slots={{
                                                transition: Zoom
                                            }}>
                                                <Button variant='contained' color='error' onClick={() => removePlan(plan)} sx={classes.tinyButton}>
                                                    Remove
                                                </Button>
                                            </Tooltip>
                                        </Grid2>
                                        <Grid2
                                            size={{
                                                xs: 7,
                                                lg: 9
                                            }}>
                                            Payment Plan: {plan.planDescription}
                                        </Grid2>
                                    </Grid2>
                                }
                                secondary={
                                    <Grid2
                                        container
                                        spacing={2}
                                        alignItems="top"
                                        style={{width: '100%'}}
                                    >
                                        <Grid2 size={12}>
                                            {`Payment Amt.: ${getDecimal(plan.planPaymentAmount)}`}
                                        </Grid2>
                                    </Grid2>
                                }
                                slotProps={{
                                    primary: {
                                        component: 'span',
                                        variant: 'body2',
                                        sx: classes.inline,
                                        color: 'textPrimary'
                                    },

                                    secondary: {
                                        component: 'span',
                                        variant: 'body2',
                                        sx: classes.inline,
                                        color: 'textPrimary'
                                    }
                                }} />
                        </ListItem>
                        <Divider sx={classes.listDivider}/>
                    </>);
                })}
                {balances && balances.length > 0 && balances.map((balance) => {
                    return (<>
                        <ListItem alignItems='flex-start' sx={classes.listPadding}>
                            <ListItemText
                                sx={classes.listText}
                                primary={
                                    <Grid2
                                        container
                                        spacing={2}
                                        alignItems="top"
                                        style={{width: '100%'}}
                                    >
                                        <Grid2
                                            size={{
                                                xs: 5,
                                                lg: 3
                                            }}>
                                            <Tooltip title='Remove balance from selected list' arrow slots={{
                                                transition: Zoom
                                            }}>
                                                <Button variant='contained' color='error' onClick={() => removeBalance(balance)} sx={classes.tinyButton}>
                                                    Remove
                                                </Button>
                                            </Tooltip>
                                        </Grid2>
                                        <Grid2
                                            size={{
                                                xs: 7,
                                                lg: 4
                                            }}>
                                            {`${getCaseLabel(court)} ${balance.caseNumber}`}
                                        </Grid2>
                                        <Grid2
                                            size={{
                                                xs: 12,
                                                lg: 5
                                            }}>
                                            {balance.description}
                                        </Grid2>
                                    </Grid2>
                                }
                                secondary={
                                    <Grid2
                                        container
                                        spacing={2}
                                        alignItems="top"
                                        style={{width: '100%'}}
                                    >
                                        { balance.partialAmt ?
                                            <>
                                                <Grid2 size={6}>
                                                    {`Payment Amt.: ${getDecimal(balance.balancePaymentAmount)}`}
                                                </Grid2>
                                                <Grid2 size={6}>
                                                    {`Total Owed: ${getDecimal(balance.courtAmount)}`}
                                                </Grid2>
                                            </> :
                                            <Grid2 size={12}>
                                                {`Payment Amt.: ${getDecimal(balance.balancePaymentAmount)}`}
                                            </Grid2>
                                        }
                                    </Grid2>
                                }
                                slotProps={{
                                    primary: {
                                        component: 'span',
                                        variant: 'body2',
                                        sx: classes.inline,
                                        color: 'textPrimary'
                                    },

                                    secondary: {
                                        component: 'span',
                                        variant: 'body2',
                                        sx: classes.inline,
                                        color: 'textPrimary'
                                    }
                                }} />
                        </ListItem>
                        <Divider sx={classes.listDivider}/>
                    </>);
                })}
                { feeResponse &&
                    <ListItem alignItems='flex-start' sx={{margin: '.5rem 1rem', padding: '1rem'}}>
                        <ListItemText
                            sx={classes.listText}
                            primary={
                                <Grid2
                                    container
                                    spacing={2}
                                    alignItems="top"
                                    style={{width: '100%'}}
                                >
                                    <Grid2 size={4}>
                                        {`${court.nonCourtOrganization ? 'Agency' : 'Court'} Amt.: ${getDecimal(feeResponse.courtAmount)}`}
                                    </Grid2>
                                    <Grid2 size={4}>
                                        {`CitePay Fee: ${getDecimal(feeResponse.citepayFee)}`}
                                    </Grid2>
                                    <Grid2 size={4}>
                                        {`Total: ${getDecimal(feeResponse.totalAmount)}`}
                                    </Grid2>
                                </Grid2>
                            }
                            secondary={
                                <>
                                    { serviceFee && serviceFee > 0 ?
                                        <Grid2
                                            container
                                            spacing={2}
                                            alignItems="top"
                                            style={{width: '100%'}}
                                        >
                                            <Grid2 sx={{marginTop: '1rem'}} size={12}>
                                                {`A payment plan service fee of $${serviceFee} has been added.`}
                                            </Grid2>
                                        </Grid2> : null
                                    }
                                </>
                            }
                            slotProps={{
                                primary: {
                                    component: 'span',
                                    variant: 'subtitle2',
                                    sx: classes.inline,
                                    color: 'textPrimary'
                                },

                                secondary: {
                                    component: 'div',
                                    variant: 'body1',
                                    color: 'secondary'
                                }
                            }} />
                    </ListItem>
                }
            </List>
            <Box component='div' sx={{display: 'flex', flexDirection: 'row-reverse', margin: '1rem'}}>
                <Button
                    variant='contained'
                    color='primary'
                    startIcon={smallScreen ? null : <PaymentsTwoToneIcon/>}
                    sx={classes.squashedButton}
                    onClick={() => openPayment()}
                >
                    Pay
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    startIcon={smallScreen ? null : <ReplayIcon/>}
                    sx={classes.squashedButton}
                    onClick={() => clearSelected()}
                >
                    Clear
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    startIcon={smallScreen ? null : <ArrowBackIosNewRoundedIcon />}
                    sx={classes.squashedButton}
                    onClick={() => setShowSelected(false)}
                >
                    Back
                </Button>
            </Box>
        </Paper>
    </>);
}

export default SelectedBalances;
